import GeneralHelper from './GeneralHelper';
import BreakpointHelper from './BreakpointHelper';

class ElementInViewHelper {
    /**
     * @param element
     * @param checkIfCompletelyVisible
     * @param offset
     * @returns {boolean}
     */
    static isScrolledIntoView(element, checkIfCompletelyVisible = false, offset = 1) {
        const rect = element.getBoundingClientRect();
        const elemTop = rect.top;
        const elemMarginBottom = parseInt(window.getComputedStyle(element).marginBottom, 10);
        const elemBottom = rect.bottom + elemMarginBottom;

        const header = document.querySelector('.page-header');
        const { height: headerHeight } = header.getBoundingClientRect();
        const windowInnerHeight = window.innerHeight;

        let isVisible = elemTop <= windowInnerHeight && elemBottom >= headerHeight;

        if (offset !== 1) {
            isVisible = elemTop < (windowInnerHeight / offset) && elemBottom >= (windowInnerHeight / offset);
        }

        if (checkIfCompletelyVisible) {
            isVisible = (elemTop >= headerHeight) && (elemBottom <= windowInnerHeight);
        }

        return isVisible;
    }

    static percentageVisible(element, evaluateFromDirection = '', offsetTop = 0, offsetBottom = 0) {
        const windowInnerHeight = window.innerHeight;
        const rect = element.getBoundingClientRect();
        const elemTop = rect.top;
        const elemMarginBottom = parseInt(window.getComputedStyle(element).marginBottom, 10);
        const elemBottom = rect.bottom + elemMarginBottom;
        let percentage = 100;

        const positionTopInViewport = windowInnerHeight - (windowInnerHeight * offsetTop) - elemTop;
        const positionBottomInViewport = elemBottom - windowInnerHeight + (windowInnerHeight * offsetBottom);

        if (positionTopInViewport < 0
            || positionTopInViewport > (windowInnerHeight - (windowInnerHeight * offsetTop) + rect.height)) {
            return 0;
        }

        if (positionTopInViewport > 0
            && positionTopInViewport <= windowInnerHeight - (windowInnerHeight * offsetTop)
            && evaluateFromDirection !== 'bottom') {
            percentage -= (100 - ((positionTopInViewport * 100) / rect.height));
        }

        if (positionBottomInViewport < 0
            && Math.abs(positionBottomInViewport) !== windowInnerHeight + (windowInnerHeight * offsetBottom)
            && evaluateFromDirection !== 'top') {
            percentage += (positionBottomInViewport * 100) / rect.height;
        }

        const clampNumber = (number, min, max) => Math.max(Math.min(number, Math.max(min, max)), Math.min(min, max));

        percentage = clampNumber(percentage, 0, 100);

        return percentage;
    }

    static mapValue(value, x1, x2, y1, y2) {
        return ((value - x1) * (y2 - y1)) / (x2 - x1) + y1;
    }

    static initAnimation(elem, breakpoint) {
        if (!breakpoint) {
            window.addEventListener('scroll', elem.throttledWindowScrollListener);
            return;
        }

        let aboveBreakpoint = BreakpointHelper.aboveBreakpoint(elem.breakpoints['screen-sm']);

        if (aboveBreakpoint) {
            window.addEventListener('scroll', elem.throttledWindowScrollListener);
        }

        window.addEventListener('resize', GeneralHelper.throttle(() => {
            const breakpointInfo = BreakpointHelper.breakpointCrossed(elem.breakpoints['screen-sm'], aboveBreakpoint);
            aboveBreakpoint = breakpointInfo.aboveBreakpoint;
            const { breakpointCrossed } = breakpointInfo;

            if (breakpointCrossed) {
                if (aboveBreakpoint) {
                    window.addEventListener('scroll', elem.throttledWindowScrollListener);

                    return;
                }

                window.removeEventListener('scroll', elem.throttledWindowScrollListener);
            }
        }, 50));
    }
}

export default ElementInViewHelper;
